/**
 * Détecte un overlay plein écran « bloquant » (même heuristique que MainLayout / AppLayout pour le hamburger).
 * Les éléments avec data-hamburger-ignore="true" sont exclus (ex. overlay menu latéral).
 */
export function hasBlockingDocumentOverlay() {
  return Array.from(document.body.querySelectorAll('*')).some((el) => {
    if (el.getAttribute('data-hamburger-ignore') === 'true') return false;
    const style = window.getComputedStyle(el);
    if (style.position !== 'fixed') return false;
    const zIndex = Number.parseInt(style.zIndex || '0', 10);
    if (Number.isNaN(zIndex) || zIndex < 900) return false;
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    const opacity = Number.parseFloat(style.opacity || '1');
    if (Number.isNaN(opacity) || opacity <= 0.01) return false;
    const rect = el.getBoundingClientRect();
    const intersectsViewport =
      rect.right > 0 && rect.bottom > 0 && rect.left < window.innerWidth && rect.top < window.innerHeight;
    if (!intersectsViewport) return false;
    return rect.width >= window.innerWidth * 0.6 && rect.height >= window.innerHeight * 0.7;
  });
}
